@if (parsedData && parsedData.length && !blocks) {
  <ul>
    @for (item of (showAll ? parsedData : parsedData | slice:0:5); track item) {
      @if (item.url || item.path) {
        <li>
          @if (item.url && !item.url.url) {
            @if ((item.url | arrayFirst); as routeUrl) {
              @if (item?.routed || routeUrl.routed) {
                <a
                  [routerLink]="routeUrl?.path || item.url"
                  [attr.target]="routeUrl?.target || '_self'"
                  [queryParams]="routeUrl?.params || false"
                  [attr.data-test-id]="'sidebar-links-link-' + (routeUrl?.path || item?.url | slugify)"
                  class="sidebar-links__link--has-icon"
                  >
                  <icon
                    size="medium"
                    ariaLabel="lehe sisene link"
                    glyph="{{ item.icon ? item.icon : 'link-2' }}"
                  ></icon>
                  <span role="text">{{ item.title }}</span>
                </a>
              }
              @if (!item?.routed && !routeUrl.routed) {
                <a
                  [href]="routeUrl?.path || item.url"
                  [attr.target]="routeUrl?.target || '_self'"
                  class="sidebar-links__link--has-icon"
                  [attr.data-test-id]="'sidebar-links-link-' + (routeUrl?.path || item?.url | slugify)"
                  >
                  <icon
                    size="medium"
                    ariaLabel="lehe väline link"
                    glyph="{{ item.icon ? item.icon : 'external-link' }}"
                  ></icon>
                  <span role="text">{{ item.title }}</span>
                </a>
              }
            }
          }
          @if (item.url?.url) {
            @if (item.url.url.routed) {
              <a
                [routerLink]="item.url.url.path"
                [attr.target]="item.url?.target || '_self'"
                [queryParams]="item.url.url.params || false"
                [attr.data-test-id]="'sidebar-links-link-' + ( item?.url?.url?.path | slugify)"
                class="sidebar-links__link--has-icon"
                >
                <icon
                  size="medium"
                  glyph="{{ item.icon ? item.icon : 'link-2' }}"
                ></icon>
                <span role="text">{{ item.title }}</span>
              </a>
            }
            @if (!item.url.url.routed) {
              <a
                [href]="item.url.url.path"
                [attr.target]="item.url?.target || '_self'"
                class="sidebar-links__link--has-icon"
                [attr.data-test-id]="'sidebar-links-link-' + ( item?.url?.url?.path | slugify)"
                >
                <icon
                  size="medium"
                  glyph="{{ item.icon ? item.icon : 'external-link' }}"
                ></icon>
                <span role="text">{{ item.title }}</span>
              </a>
            }
          }
          @if (item.path) {
            @if (item.routed) {
              <a
                [routerLink]="item.path"
                [attr.target]="item?.target || '_self'"
                [queryParams]="item.params || false"
                class="sidebar-links__link--has-icon"
                [attr.data-test-id]="'sidebar-links-link-' + ( item?.path | slugify)"
                >
                <icon
                  size="medium"
                  glyph="{{ item.icon ? item.icon : 'link-2' }}"
                ></icon>
                <span role="text">{{ item.title }}</span>
              </a>
            }
            @if (!item.routed) {
              <a [href]="item.path" [attr.target]="item?.target || '_self'"
                [attr.data-test-id]="'sidebar-links-link-' + ( item?.path | slugify)"
                class="sidebar-links__link--has-icon">
                <icon
                  size="medium"
                  glyph="{{ item.icon ? item.icon : 'external-link' }}"
                ></icon>
                <span role="text">{{ item.title }}</span>
              </a>
            }
          }
        </li>
      }
      @if (item.uri && !item.path) {
        <li>
          <a [href]="item.uri" [attr.target]="item.target || '_self'"
            [attr.data-test-id]="'sidebar-links-link-' + ( item?.uri | slugify)"
            class="sidebar-links__link--has-icon">
            <icon
              size="medium"
              glyph="{{ item.icon ? item.icon : 'external-link' }}"
            ></icon>
            <span role="text">{{ item.title }}</span>
          </a>
        </li>
      }
      @if (!item.url && !item.uri && !item.title) {
        <li class="text-instance">
          {{ item }}
        </li>
      }
      @if (!item.url && !item.uri && item.title) {
        <li>
          <a class="no-link">
            <span role="text">{{ item.title }}</span>
          </a>
        </li>
      }
    }
    @if (parsedData.length > 5) {
      <div class="bottom">
        <button
          htm-button
          theme="plain"
          class="showMore"
          (click)="showAll = !showAll"
          data-test-id="sidebar-links-show-more-toggle-button"
          attr.aria-label="{{ ('button.show_' + (showAll ? 'less' : 'more')) | translate }}"
          >
          @if (showAll) {
            - {{ 'button.show_less' | translate }} ({{ parsedData.length - 5 }})
          } @else {
            + {{ 'button.show_more' | translate }} ({{ parsedData.length - 5 }})
          }
        </button>
      </div>
    }
  </ul>
}

@if (blocks) {
  @for (block of blocks; track block) {
    <block theme="sidebar">
      <block-title>
        <ng-container>{{ block.title }}</ng-container>
      </block-title>
      <block-content>
        <sidebar-links [data]="block.links"></sidebar-links>
      </block-content>
    </block>
  }
}
